// extracted by mini-css-extract-plugin
export default {"title":"_1QCZFHqJ","signUpContainer":"_38vpaoUJ"};